import React from 'react';
import {
    Button,
    Div,
    Panel,
    PanelHeader,
    SplitCol,
    SplitLayout,
    View,
    Spinner,
    Banner
} from "@vkontakte/vkui";

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import DateRangePicker from "@wojtekmaj/react-daterange-picker";

import {Icon24DownloadOutline} from "@vkontakte/icons";

import BaseComponent from "../components/BaseComponent";
import {OfflineProvider} from "../contexts/OfflineContext";
import SalePointsApi from "../api/references/salePoints";
import {ACCESS_DENIED_MESSAGE, isTradeDesigner} from "../assets/constants";


class DataLensExport extends BaseComponent {

    constructor(props) {
        super(props);

        // По умолчанию: 12 месяцев назад - сегодня
        const today = new Date();
        const yearAgo = new Date();
        yearAgo.setFullYear(yearAgo.getFullYear() - 1);

        const state = {
            dateValue: [yearAgo, today],
            isExporting: false,
            dateRangeIsOpen: false
        };

        this.state = {
            ...this.state,
            ...state
        };
    }

    dateChange = (value) => {
        if (value && value[0] && value[1]) {
            this.setState({dateValue: value});
        }
    }

    handleExport = () => {
        if (isTradeDesigner(this.props.current_user)) {
            window.postMessage({type: 'error', text: ACCESS_DENIED_MESSAGE, timeout: 3000});
            return;
        }
        const [dateFrom, dateTo] = this.state.dateValue;

        // Валидация: date_from должна быть раньше или равна date_to
        if (dateFrom > dateTo) {
            alert('Дата начала должна быть раньше или равна дате окончания');
            return;
        }

        this.setState({isExporting: true});

        const url = SalePointsApi.getDataLensExportUrl(dateFrom, dateTo);
        window.open(url, '_blank');

        // Через 3 секунды скрываем спиннер (файл начнёт качаться)
        setTimeout(() => {
            this.setState({isExporting: false});
        }, 3000);
    }

    render() {
        const isDesigner = isTradeDesigner(this.props.current_user);
        return (
            <OfflineProvider>
                <View activePanel="datalens_export_panel">
                    <Panel id="datalens_export_panel">
                        <SplitLayout>
                            {this.MainMenu()}
                            <SplitCol>
                                <PanelHeader>Экспорт в Yandex DataLens</PanelHeader>
                                {isDesigner ? (
                                    <Div>
                                        <Banner
                                            before={<span style={{fontSize: '24px'}}>🚫</span>}
                                            header={ACCESS_DENIED_MESSAGE}
                                            subheader="Экспорт DataLens недоступен для роли Дизайнер"
                                            mode="info"
                                        />
                                    </Div>
                                ) : (
                                    <>
                                <Div>
                                    <Banner
                                        before={<span style={{fontSize: '24px'}}>⏳</span>}
                                        header="Формирование отчёта"
                                        subheader="Формирование отчёта может занять несколько минут при большом объёме данных"
                                        mode="info"
                                    />
                                </Div>

                                <Div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '16px',
                                        maxWidth: '400px'
                                    }}>
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                fontWeight: '500'
                                            }}>
                                                Период выгрузки
                                            </label>
                                            <DateRangePicker
                                                onCalendarClose={() => setTimeout(() => this.setState({dateRangeIsOpen: false}), 1000)}
                                                onClick={() => this.setState({dateRangeIsOpen: true})}
                                                showLeadingZeros={true}
                                                value={this.state.dateValue}
                                                isOpen={this.state.dateRangeIsOpen}
                                                onChange={this.dateChange}
                                                format="dd.MM.y"
                                                locale="ru-RU"
                                            />
                                        </div>

                                        <Button
                                            size="l"
                                            mode="primary"
                                            before={this.state.isExporting ? <Spinner size="small"/> : <Icon24DownloadOutline/>}
                                            onClick={this.handleExport}
                                            disabled={this.state.isExporting}
                                            style={{marginTop: '8px'}}
                                        >
                                            {this.state.isExporting ? 'Формирование...' : 'Скачать Xlsx'}
                                        </Button>
                                    </div>
                                </Div>
                                    </>
                                )}
                            </SplitCol>
                        </SplitLayout>
                    </Panel>
                </View>
            </OfflineProvider>
        );
    }
}

export default DataLensExport;
